import { maestroApiCall } from '@michelin/central-provider';
import { useQuery } from 'react-query';
import { baseURL } from 'Types/APITypes';

async function getCustomer(stNumber: string) {
  if (!stNumber) return null;
  const res = await maestroApiCall({ method: 'GET', endpoint: `locations/${stNumber}/customer`, baseURL });
  return res;
}

export default function useCustomer(stNumber: string) {
  return useQuery(['customer', stNumber], () => getCustomer(stNumber));
}
